import { Component, input, output } from '@angular/core';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { DisabilityKind } from '../../../../api/app-types/disability-type.app';
import { Paginator } from '../../../../core/components/paginator/paginator';
import { DisabilityTypeItem } from '../disability-type-item/disability-type-item';

@Component({
	selector: 'lvr-disability-type-list',
	templateUrl: './disability-type-list.html',
	styleUrl: './disability-type-list.scss',
	imports: [TranslocoPipe, DisabilityTypeItem, MatPaginatorModule, Paginator, RouterLink],
})
export class DisabilityTypeList {
	public readonly disabilityTypes = input.required<DisabilityKind[]>();
	public readonly totalItems = input.required<number>();
	public readonly pageIndex = input.required<number>();
	public readonly pageSize = input.required<number>();
	public readonly showFirstLastButtons = input<boolean>(true);
	public readonly hidePageSize = input<boolean>(false);
	public readonly pageChange = output<PageEvent>();

	/**
	 * Handles the page event
	 * @param event The page event
	 */
	public handlePageEvent(event: PageEvent) {
		this.pageChange.emit(event);
	}
}
